export const c_page__header_tools_c_button_m_selected_notification_badge_m_unread_after_BackgroundColor = {
  "name": "--pf-c-page__header-tools--c-button--m-selected--notification-badge--m-unread--after--BackgroundColor",
  "value": "#004080",
  "var": "var(--pf-c-page__header-tools--c-button--m-selected--notification-badge--m-unread--after--BackgroundColor)"
};
export default c_page__header_tools_c_button_m_selected_notification_badge_m_unread_after_BackgroundColor;